export default "__VITE_ASSET__DnmlNoGB__"